import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { studio } from "@/lib/studioApi";

const RHYTHMS = [["7", "Toutes les semaines", "J+7 · J+14 · J+21"], ["14", "Toutes les 2 semaines", "J+14 · J+28 · J+42"], ["30", "Tous les mois", "J+30 · J+60 · J+90"]];
const TONES = [["courtois", "Courtois", "Sauf erreur de notre part…"], ["neutre", "Neutre", "Merci de régler sous 7 jours"], ["ferme", "Ferme", "Dernier rappel avant mise en demeure"]];

export const ReminderSettings = ({ profile, setProfile }) => {
  const rhythm = profile.invoice_reminder_rhythm || "7";
  const tone = profile.invoice_reminder_tone || "courtois";
  const [preview, setPreview] = useState(null);
  const [step, setStep] = useState(0);

  useEffect(() => {
    setPreview(null);
    studio.get("/reminder-preview", { params: { rhythm, tone } }).then(({ data }) => setPreview(data)).catch(() => {});
  }, [rhythm, tone]);

  const pick = (key, value) => setProfile((p) => ({ ...p, [key]: value }));
  const choice = (key, current, value, label, hint, testId) => (
    <button
      key={value}
      type="button"
      data-testid={testId}
      onClick={() => pick(key, value)}
      aria-pressed={current === value}
      className={`flex-1 rounded-xl border px-3 py-2.5 text-left transition-colors ${current === value ? "border-[#3A5CC8] bg-[#EEF1FC]" : "border-[#E2E7F7] bg-white hover:border-[#C7D2F5]"}`}
    >
      <span className={`block text-sm font-semibold ${current === value ? "text-[#3A5CC8]" : "text-[#0F2645]"}`}>{label}</span>
      <span className="block text-[11px] text-[#5C6A87]">{hint}</span>
    </button>
  );

  return (
    <div data-testid="reminder-settings" className="mt-3 space-y-3 rounded-xl border border-[#E2E7F7] bg-white px-4 py-3">
      <div>
        <p className="text-[11px] font-bold uppercase tracking-wide text-[#5C6A87]">Rythme des relances</p>
        <div className="mt-1.5 flex flex-col gap-2 sm:flex-row">
          {RHYTHMS.map(([v, l, h]) => choice("invoice_reminder_rhythm", rhythm, v, l, h, `reminder-rhythm-${v}`))}
        </div>
      </div>
      <div>
        <p className="text-[11px] font-bold uppercase tracking-wide text-[#5C6A87]">Ton du message</p>
        <div className="mt-1.5 flex flex-col gap-2 sm:flex-row">
          {TONES.map(([v, l, h]) => choice("invoice_reminder_tone", tone, v, l, h, `reminder-tone-${v}`))}
        </div>
      </div>
      <div data-testid="reminder-preview" className="rounded-xl bg-[#F6F8FD] p-3">
        <div className="flex flex-wrap items-center gap-1.5">
          <span className="mr-1 text-[11px] font-bold uppercase tracking-wide text-[#5C6A87]">Aperçu</span>
          {[0, 1, 2].map((i) => (
            <button key={i} type="button" data-testid={`reminder-preview-step-${i + 1}`} onClick={() => setStep(i)} className={`rounded-full px-2.5 py-0.5 text-[11px] font-bold ${step === i ? "bg-[#0F2645] text-white" : "bg-white text-[#5C6A87] border border-[#E2E7F7]"}`}>
              Relance {i + 1}{preview ? ` · J+${preview.steps[i]}` : ""}
            </button>
          ))}
        </div>
        <p data-testid="reminder-preview-text" className="mt-2 whitespace-pre-line text-xs leading-relaxed text-[#0F2645]">
          {preview ? preview.texts[step] : <Loader2 className="h-3.5 w-3.5 animate-spin text-[#93A0BC]" />}
        </p>
        <p className="mt-2 text-[11px] text-[#93A0BC]">Le même ton est utilisé par le bouton « Relancer » de la liste des factures. Le lien de paiement est toujours joint.</p>
      </div>
    </div>
  );
};
